// src/contexts/AuthContext.js
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import {
  signInWithPopup,
  GoogleAuthProvider,
  signOut as firebaseSignOut
} from 'firebase/auth';
import { auth } from '../config/firebase';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);


    const fetchToken = useCallback(async (user) => {
        if(user) {
          try {
            const token = await user.getIdToken(true);
            setToken(token);
            return token
            } catch (error) {
              console.error('Error fetching token after signin:', error);
                setToken(null);
                setUser(null);
            }
        } else {
          setToken(null);
            setUser(null);
        }

    }, [])


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
        setLoading(true);
      try {
          const token = await fetchToken(user)
            setUser(user);
            setLoading(false)
      } catch (error) {
        console.error('Error handling auth state change', error);
          setLoading(false);
      }
    });

    return unsubscribe;
  }, [fetchToken]);

  const signIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const token = await fetchToken(result.user)
        return token;
    } catch (error) {
      console.error('Error signing in with Google:', error);
      throw error;
    }
  };

  const signOut = async () => {
    try {
      await firebaseSignOut(auth);
       setToken(null);
    } catch (error) {
      console.error('Error signing out:', error);
      throw error;
    }
  };

  const value = {
    user,
    token,
    signIn,
    signOut,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};